import coreReducer, { initialCoreState } from './reducers/core';
import subscriptionReducer, { initialSubscriptionState } from './reducers/subscription';

export const createAppInitialState = (initialState = {}) => ({
  ...initialCoreState,
  ...initialSubscriptionState,
  ...initialState,
});

const createAppReducer = (customReducers = {}) => {
  const reducers = {
    core: coreReducer,
    subscription: subscriptionReducer,
    ...customReducers,
  };

  return (state, action) =>
    Object.keys(reducers).reduce((acc, reducerKey) => {
      const reducer = reducers[reducerKey];

      if (reducer) {
        return { ...acc, ...reducer(acc, action) };
      }

      return { ...acc };
    }, state);
};

export default createAppReducer;
